import { Component, Input, OnInit } from '@angular/core';
import { Appeaz } from '../../tools/models/appeaz';
import { User } from '../../tools/models/user';
import { UserService } from '../../tools/services/user.service';
import { AlertType, EazlyMessage, MessageCause } from '../../tools/services/messaging/eazly-message';
import { VersionService } from '../../tools/services/version.service';
import { Router } from '@angular/router';
import { MessagingService } from '../../tools/services/messaging/messaging.service';
import { AppeazService } from '../../tools/services/appeaz.service';
import { NGXLogger } from 'ngx-logger';


@Component({
  selector: 'eazly-appeaz-list-item',
  templateUrl: './appeaz-list-item.component.html',
  styleUrls: ['./appeaz-list-item.component.scss'],
  providers: []
})
export class AppeazListItemComponent implements OnInit {
  @Input()
  appeaz: Appeaz;

  user: User;
  isConfiguration: boolean;
  isUsers: boolean;
  isPublish: boolean;
  isEdit: boolean;
  errorMessage: EazlyMessage;

  constructor(private readonly userService: UserService, private readonly versionService: VersionService, private readonly router: Router,
    private readonly messagingService: MessagingService, private readonly appeazService: AppeazService, private readonly logger: NGXLogger
  ) { }

  ngOnInit() {
    this.user = this.userService.getCurrentUser();
    this.isConfiguration = false;
    this.isUsers = false;
    this.isPublish = false;
    this.isEdit = true;
    if (this.user.eazly_role === 'EAZLY_PLATFORM_ADMIN') {
      this.isConfiguration = true;
      this.isUsers = true;
      this.isEdit = false;
      this.appeaz.role = 'Manager';
    } else if (this.appeaz.role === 'Manager') {
      this.isUsers = true;
      this.isPublish = true;
    } else if (this.appeaz.role === 'Publisher') {
      this.isPublish = true;
    }
  }

  public redirectIfCompatible(): void {
    this.appeazService.getAppeazJWT(this.appeaz.id, this.appeaz.role).then(
      (dataJWT) => {
        this.logger.debug('JWT received');
        this.versionService.checkCompatibility(this.appeaz).then(
          (isCompatible) => {
            if (!isCompatible) {
              this.logger.debug('The version of api is not compatible with the version of Studio eazly ');
              this.errorMessage = new EazlyMessage(
                AlertType.danger,
                this.versionService.currentEazlyVersion,
                MessageCause.WrongEazlyStudioVersion,
                `${this.versionService.currentEazlyVersion};${this.versionService.compatibleVersion};${this.versionService.URLCompatibleversion}`
              );
              this.messagingService.notifyError(this.errorMessage);
            } else {
              this.logger.debug('The version of api is compatible with the version of Studio eazly');
              this.logger.debug('Navigating to editor');
              this.router.navigate(['/editor/' + this.appeaz.id]);
            }
          }
        );
      }
    );
  }

}
